// removed by extract-text-webpack-plugin
module.exports = {"bigMap":"src-pages----Karte-module---bigMap---2wuTF","smallMap":"src-pages----Karte-module---smallMap---1EWVW"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Karte.module.css
// module id = 62
// module chunks = 168707334958949